const messages = {
  title: "Mein Profil",
  desc: "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Daten aktualisieren oder anpassen und Ihren Posteingang einsehen.",
  descStaff:
    "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Daten aktualisieren oder anpassen.",
  buttons: {
    showProfile: "Profil anzeigen",
    userProfile: "ZUM STAMMDATEN",
    mailbox: "ZUM POSTEINGANG",
    addNewEmail: "Add new email",
  },
  categories: {
    baseData: {
      title: "Stammdaten",
      desc: "Vervollständigen Sie Ihre persönlichen und Unternehmensdaten für eine korrekte Registrierung.",
    },
    mailbox: {
      desc: "Empfangen Sie wichtige Nachrichten, Bestellbestätigungen und Neuigkeiten in Ihrem Posteingang.",
    },
    bankstatement: {
      title: "Kontoauszug",
      desc: "Hier können Sie den Status Ihres persönlichen Bridgestone Plus-Kontos einsehen und Ihre gesammelten und verwendeten Prämienpunkte überprüfen.",
    },
  },
  profile: {
    general: "PERSÖNLICHE DATEN UNTERNEHMENSDATEN",
    title: "Stammdaten",
    description:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie deine Daten aktualisieren oder anpassen.",
    block_description:
      "Willkommen in Ihrem persönlichen Bereich. Hier können Sie Ihre Daten einsehen",
    personalData: "PERSÖNLICHE DATEN",
    password: "Passwort",
    password1: "Passwort (optional)*",
    password2: "Passwort (wiederholen)*",
    formOfAddress: "Anrede",
    choose: "Anrede auswählen",
    mr: "Herr",
    mrs: "Frau",
    diverse: "Sonstiges",
    firstname: "Vorname",
    surname: "Nachname",
    position: "POSITION IM UNTERNEHMEN",
    operatingData: "UNTERNEHMENSDATEN",
    company: "Unternehmen",
    legalForm: "Rechtsform",
    name: "Name",
    streetHouseNr: "Straße und Hausnummer",
    street: "Straße",
    postcode: "Postleitzahl",
    location: "Stadt",
    country: "Land",
    de: "Deutschland",
    at: "Österreich",
    ch: "Schweiz",
    nl: "Niederlande",
    it: "Italien",
    language: "Sprache",
    french: "Französisch",
    italian: "Italienisch",
    german: "Deutsch",
    nederland: "Niederländisch",
    phone: "Telefon",
    website: "Website",
    operatingIndicators: "Betriebskennzahlen",
    tireSale: "Jährlicher Reifenverkauf ca. in Stückzahlen",
    tireSaleLabel: "Reifenverkauf in großen Mengen",
    inches: "Davon ≥ 18 Zoll (in %)",
    inchesLabel: "Davon 18 Zoll oder mehr in %",
    segmentSale:
      "Reifenverkauf nach Segment (Anteil Budget / Mittelklasse / Premium in %)",
    premBudget: "Premium",
    midBudget: "Mittelklasse",
    budBudget: "Budget",
    distribution: "VERTEILUNG SOMMER / WINTER / GANZJAHR (in %)",
    summerIn: "Hinein in den Sommer",
    winterIn: "Der Winter ist da",
    allSeasonIn: "Die ganze Saison über",
    tyreSizes: "Anzahl der Saisonlagerplätze (Reifensätze)",
    diffDeliveryAddres: "Lieferadresse hinzufügen",
    yourEmailAddress: "Deine E-Mail-Adresse.",
    clientNr: "Kundennummern",
    clientNrSingular: "Kundennummer",
    clientNrContent:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br /><br /> Für eine korrekte Zuordnung Ihrer Reifenbestellungen bei Großhändlern und/oder Bridgestone geben Sie bitte Ihre jeweiligen Kundennummern an. <br/><br/>Wenn Sie mehrere Kundennummern nutzen (z. B. für Hauptgeschäft und Filialen), tragen Sie bitte zuerst die Nummer Ihres Hauptgeschäfts ein. Bestellungen über weitere Kundennummern werden automatisch zugeordnet.<br/><br/>Bestellen Sie auch Reifen unter anderen Kundennummern? Diese fügen wir gerne für Sie hinzu. Bitte wenden Sie sich dazu an Ihre Bridgestone-Ansprechpartnerin oder Ihren Bridgestone-Ansprechpartner. Die Kontaktdaten finden Sie auf der Seite <b>„Service & Kontakt“</b>.",
    supplySource: "Bezugsquelle",
    email: "E-Mail-Adresse",
    staffEmail: "E-Mail-Adresse des Teilnehmers",
    registered: "Registriert am",
    registeredAt: "Registriert am",
    lastLogIn: "Letzter Login",
    details: "Details",
    inDetail: "{name} im Detail",
    customerFile: "Kundenakte",
    customerHistory: "Kundenhistorie",
    currentYear: "Laufendes Jahr",
    bsClientNr: "Bridgestone Kundennummer",
    bftClientNr: "Best4Tires Kundennummer",
    acceptTerms: "Akzeptieren Sie die Teilnahmebedingungen.",
    newCustomerNumbersInfo:
      "<span class='text-danger fw-bold'>WICHTIG - BITTE LESEN:</span><br />Bei der ersten Eingabe der Kundennummer werden Ihre Daten auf Genauigkeit und Erfüllung unserer Verteilungskriterien überprüft. Die Entscheidung, die Kundennummer(n) zu aktivieren und mit Ihrem Profil zu verknüpfen, kann bis zu 5 Werktage in Anspruch nehmen.",
    selectWholeSaler: "beim Lieferanten (bitte wählen)",
    cooperation: "MITGLIED / ZUSAMMENARBEIT",
    error100: "Die Summe der Werte muss 100% betragen.",
    errorRange: "Der Wert muss zwischen 0 und 100 liegen",
    btw_number_label: "Unternehmens-USt-IdNr.",
    btw_number: "Umsatzsteuer-Identifikationsnummer",
    mobile: "Telefonnummer",
    mobile_label: "Deine Mobiltelefonnummer",
    iban_number: "Deine Unternehmens-IBAN",
    iban_number_label: "IBAN-Nummer",
    yourCsNr: "Kundennummern",
    yourLastName: "Nachname",
    positionLabel: "Wählen Sie eine Position",
    yourFirstName: "Vorname",
    companyLabel: "Unternehmen",
    numberOfSetsOfSeasonalTiresBudget: "Jährliche Lagerung",
    contactInfo: "Wenn Sie Fragen haben, kontaktieren Sie uns bitte: {email}",
    addAnotherCsNumber: "Kundennummer hinzufügen",
    activityAndProfile: "GESCHÄFTSBEZIEHUNG UND PROFIL",
    financialEmail: "Financial emails",
    indirectCustomNumberHelpMessage:
      "Wir konnten deine Kundennummer-Einstellung nicht erkennen. Bitte überprüfe dein Profil und bestätige, ob du ein direkter oder indirekter Kunde bist, um fortzufahren.",
    breakTimes: "Pausenzeiten",
    restDay: "Ruhetag",
    pause: "PAUSE",
    completeProfile: "Persönliches Profil vervollständigen und zusätzlich",
    completeProfileBold: "300 Punkte sichern.",
    fullCompleteProfile: "Ihr persönliches Profil ist vollständig! ",
  },
  countries: {
    al: "Albanien",
    ad: "Andorra",
    at: "Österreich",
    be: "Belgien",
    by: "Belarus",
    ba: "Bosnien und Herzegowina",
    bg: "Bulgarien",
    hr: "Kroatien",
    cy: "Zypern",
    cz: "Tschechien",
    dk: "Dänemark",
    ee: "Estland",
    fi: "Finnland",
    fr: "Frankreich",
    ge: "Georgien",
    gr: "Griechenland",
    es: "Spanien",
    nl: "Niederlande",
    ie: "Irland",
    is: "Island",
    kz: "Kasachstan",
    xk: "Kosovo",
    li: "Liechtenstein",
    lt: "Litauen",
    lu: "Luxemburg",
    lv: "Lettland",
    mk: "Nordmazedonien",
    mt: "Malta",
    md: "Moldau",
    mc: "Monaco",
    de: "Deutschland",
    no: "Norwegen",
    pl: "Polen",
    pt: "Portugal",
    ru: "Russland",
    ro: "Rumänien",
    sm: "San Marino",
    rs: "Serbien",
    sk: "Slowakei",
    si: "Slowenien",
    se: "Schweden",
    ch: "Schweiz",
    tr: "Türkei",
    ua: "Ukraine",
    hu: "Ungarn",
    gb: "Vereinigtes Königreich",
    it: "Italien",
    va: "Vatikanstadt",
  },
  addCsNumber: {
    title: "Notice",
    body: "Are you sure you want to save this customer number? The action blocks edit data until the administrator approves it.",
  },
  extraEmailSection: {
    description:
      "Extra email addresses are exclusively used for sending BS+ marketing information and/or financial information and should <b>under no circumstances be used for logging in or managing</b> the Bridgestone PLUS account.",
    optionOne: "For financial info (e.g., bonus specification)",
    optionTwo:
      "For Bridgestone Plus marketing communication (e.g., promotions/newsletters)",
    addNewEmail: "Add new email address",
  },
};

export default {
  messages,
};
